// extracted by mini-css-extract-plugin
module.exports = {"instrument":"InstrumentSelector_instrument__3WTEc"};